import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import packingService from '../services/packing.service';


export const fetchPackingModeList = createAsyncThunk(
  'packing/fetchPackingModeList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await packingService.getPackingModeList(page, pagesize, search, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedPackingModeList = createAsyncThunk(
  'packing/fetchArchivedPackingModeList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await packingService.getPackingModeArchiveList(page, pagesize, search, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchPackigModeById = createAsyncThunk(
  'packing/fetchPackigModeById',
  async (packingModeId, { rejectWithValue }) => {
    try {
      const response = await packingService.getPackingModeById(packingModeId);
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createPackingMode = createAsyncThunk(
  'packing/createPackingMode',
  async ({ payload }, thunkAPI) => {
    try {
      const response = await packingService.addPackingMode(payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updatePackingMode = createAsyncThunk(
  'packing/updatePackingMode',
  async ({ id, values }, thunkAPI) => {
    try {
      
      const response = await packingService.editPackingMode(id, values);
      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletePackingMode = createAsyncThunk(
  'packing/deletePackingMode',
  async (id, thunkAPI) => {
    try {
      await packingService.deletePackingMode(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const unArchivePacking = createAsyncThunk(
  'packing/unArchivePacking',
  async (id, thunkAPI) => {
    try {
      await packingService.unArchivePackingRecord(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



const initialState = {
  data: [],
  archiveData: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  error: null,
  loading: false,
  hasMore: true,
};

const packingSlice = createSlice({
  name: 'packing',
  initialState,
  reducers: {
    resetPackingModeData: (state) => {
      state.data = []; // This will clear the list
    },
    resetArchiveData: (state) => {
      state.archiveData = []; // This will clear the list
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPackingModeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPackingModeList.fulfilled, (state, action) => {
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results?.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchPackingModeList.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedPackingModeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchArchivedPackingModeList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.archiveData = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchArchivedPackingModeList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchPackigModeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackigModeById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPackigModeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createPackingMode.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPackingMode.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createPackingMode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(updatePackingMode.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePackingMode.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(updatePackingMode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(deletePackingMode.pending, state => {
        state.loading = true;
      })
      .addCase(deletePackingMode.fulfilled, (state, action) => {
        state.data = state.data.filter(group => group.id !== action?.meta?.arg); // Remove the deleted group from state
        state.totalRecord = state.totalRecord - 1;
        state.loading = false;
      })
      .addCase(deletePackingMode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(unArchivePacking.pending, state => {
        state.loading = true;
      })
      .addCase(unArchivePacking.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.archiveData = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.loading = false;
      })
      .addCase(unArchivePacking.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});


export const { resetPackingModeData, resetArchiveData } = packingSlice.actions;
export default packingSlice.reducer;


